module.exports = __webpack_public_path__ + "img/multiple-m.0260c79b.png";